import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AiOutlinePlusCircle } from "react-icons/ai";
import MuiTableCustomer from "./MuiTableCustomer";
import { CustomerList } from "../../../services/helpers/customers";
import { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import Cookies from "js-cookie";

const ListView = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const CustomersState = useSelector((state) => state.customersReducers);
  const [totalPageNumber, setTotalPageNumber] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [customerLists, setCustomerLists] = useState([]);
  const clickLink = (pathname) => {
    navigate(pathname);
  };

  const getCustomerList = () => {
    setLoading(true)
    const queryParams = {
      pageNum: pageNum,
      userId: Cookies.get('userId')
    };
    const paramsData = { queryParams, headers: {},
    isAuthorized: true, };
    CustomerList(paramsData, (res) => {
      setCustomerLists(res.data.customerList);
      setTotalPageNumber(res?.data?.pagination?.last_page);
      setLoading(false)
    });
  };

  const opPageChange = (e, page_number) => {
    e.preventDefault();
    setPageNum(page_number);
  };

  useEffect(() => {
    getCustomerList();
  }, [pageNum]);

  return (
    <div
      className={`w-full  ${CustomersState.id && "-lg:hidden"} shadow-xl`}
      // style={{backgroundColor:'gray'}}
    >
      <div className="flex justify-between p-2 items-center">
        <div className="text-xl">Active Customers</div>
        <div className="flex">
          <button
            type="submit"
            className="text-f-button flex items-center gap-1 "
            onClick={() => {
              clickLink("/customer/new");
            }}
          >
            <AiOutlinePlusCircle /> New
          </button>
        </div>
      </div>
      <hr />
      <div className="">
      {loading ? (
          <Loader classes="min-h-screen" />
        ) : (
        <MuiTableCustomer 
        totalPageNumber={totalPageNumber}
        opPageChange={opPageChange}
        cId={CustomersState.id} 
        pageNum={pageNum}
        CustomerLists={customerLists}
        getCustomerList={getCustomerList}
         />
        )}
      </div>
    </div>
  );
};

export default ListView;
